import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import leaderBoardWinnerList from './components/leaderBoardWinnerList.vue'
import RoomListing from './views/RoomListing.vue'
import LiveVideo from './views/liveVideo.vue'
import slidingTab from './components/slidingTab.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/leaderBoardWinnerList',
      name: 'leaderBoardWinnerList',
      component: leaderBoardWinnerList
    },
    {
      path: '/video',
      name: 'liveVideo',
      component: LiveVideo
    },
    {
      path: '/slidingTab',
      name: 'slidingTab',
      component: slidingTab
    }
  ]
})
